// import React, { useState } from "react";

// const Preview = () => {
//   const [isVisible, setIsVisible] = useState(false);
//   const [selectedContainer, setSelectedContainer] = useState(null);
//   const containers = [
//     { id: 1, url: "/images/image1.jpg", alter: "invoice1" },
//     { id: 2, url: "/images/image2.jpg", alter: "invoice2" },
//     { id: 3, url: "/images/image3.jpg", alter: "invoice3" },
//     { id: 4, url: "/images/image4.png", alter: "invoice4" },
//   ];
//   const handleToggle = () => {
//     setIsVisible(!isVisible);
//   };

//   const handleHitterClick = () => {
//     setIsVisible(false);
//   };

//   const togglePopup = (id) => {
//     setSelectedContainer(selectedContainer === id ? null : id);
//   };

//   const handleClickOutside = (e) => {
//     if (selectedContainer && !e.target.closest(".popup-content")) {
//       setSelectedContainer(null);
//     }
//   };

//   return (
//     <>
//       <div style={styles.wrap}>
//         <button
//           style={styles.button}
//           onClick={handleToggle}
//           aria-expanded={isVisible}
//         >
//           Preview / HIDE
//         </button>
//         {isVisible && (
//           <div style={styles.hitter} onClick={handleHitterClick}></div>
//         )}
//       </div>
//       <div
//         style={{
//           width: "100%",
//           display: "flex",
//           justifyContent: "center",
//           marginTop: "50px",
//           marginBottom: "100px",
//         }}
//       >
//         {isVisible && (
//           <div style={styles.content}>
//             <div
//               style={{
//                 display: "flex",
//                 // justifyContent: "center",
//                 // alignItems: "center",
//                 // backgroundColor: "gray",
//                 width: "100%",
//                 height: "inherit",
//               }}
//             >
//               {containers.map((data) => {
//                  <div style={styles.imagecontainer}>
//                  <img
//                    src={data.url}
//                    alt={data.alter}
//                    style={{ objectFit: "cover", height: "100%", width: "auto" }}
//                  />
//                </div>
//               })}
//               {/* <div style={styles.imagecontainer}>
//                 <img
//                   src="/images/image1.jpg"
//                   alt="Image 1"
//                   style={{ objectFit: "cover", height: "100%", width: "auto" }}
//                 />
//               </div>
//               <div style={styles.imagecontainer}>
//                 <img
//                   src="/images/image2.jpg"
//                   alt="Image 2"
//                   style={{ objectFit: "cover", height: "100%", width: "auto" }}
//                 />
//               </div>
//               <div style={styles.imagecontainer}>
//                 <img
//                   src="/images/image3.jpg"
//                   alt="Image 3"
//                   style={{ objectFit: "cover", height: "100%", width: "auto" }}
//                 />
//               </div>
//               <div style={styles.imagecontainer}>
//                 <img
//                   src="/images/image4.png"
//                   alt="Image 4"
//                   style={{ objectFit: "cover", height: "100%", width: "auto" }}
//                 />
//               </div> */}
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// const styles = {
//   wrap: {
//     margin: "0 20px 0 0",
//     display: "flex",
//     justifyContent: "center",
//     alignitems: "center",
//   },
//   button: {
//     cursor: "pointer",
//     padding: "10px 15px",
//   },
//   content: {
//     // backgroundColor: "#444",
//     width: "auto",
//     height: "250px",
//     position: "absolute",
//     height: "170px",
//     paddingRight: "10px",
//   },
//   hitter: {
//     width: "100vw",
//     height: "100vh",
//     position: "absolute",
//     top: 0,
//     left: 0,
//     zIndex: 1,
//   },
//   imagecontainer: {
//     width: "100px",
//     height: "inherit",
//     margin: "10px",
//     padding: "0 20px",
//     border: "2px solid black",
//   },
// };

// export default Preview;

// ==================================================================>
// ==================================================================>
// ==================================================================>
// ==================================================================>

// import React, { useState } from "react";
// import Invoice1 from "../Forms/invoice1/Invoice1";
// import Invoice2 from "../Forms/invoice2/Invoice2";
// import Invoice3 from "../Forms/invoice3/Invoice3";
// import Invoice4 from "../Forms/invoice4/Invoice4";

// const Preview = () => {
//   const [isVisible, setIsVisible] = useState(false);
//   const [selectedContainer, setSelectedContainer] = useState(null);
//   const containers = [
//     { id: 1, url: "/images/image1.jpg", alter: "invoice1" },
//     { id: 2, url: "/images/image2.jpg", alter: "invoice2" },
//     { id: 3, url: "/images/image3.jpg", alter: "invoice3" },
//     { id: 4, url: "/images/image4.png", alter: "invoice4" },
//   ];
//   const handleToggle = () => {
//     setIsVisible(!isVisible);
//   };

//   const handleHitterClick = () => {
//     setIsVisible(false);
//   };

//   const togglePopup = (id) => {
//     setSelectedContainer(selectedContainer === id ? null : id);
//   };

//   const handleClickOutside = (e) => {
//     if (selectedContainer && !e.target.closest(".popup-content")) {
//       setSelectedContainer(null);
//     }
//   };

//   return (
//     <>
//       <div style={styles.wrap}>
//         <button
//           style={styles.button}
//           onClick={handleToggle}
//           aria-expanded={isVisible}
//         >
//           Preview / HIDE
//         </button>
//         {isVisible && (
//           <div style={styles.hitter} onClick={handleHitterClick}></div>
//         )}
//       </div>
//       <div
//         style={{
//           width: "100%",
//           display: "flex",
//           justifyContent: "center",
//           marginTop: "50px",
//           marginBottom: "100px",
//         }}
//       >
//         {isVisible && (
//           <div style={styles.content}>
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 backgroundColor: "gray",
//                 width: "100%",
//                 height: "inherit",
//               }}
//             >
//               {containers.map((data) => {
//                 <div style={styles.imagecontainer}>
//                   <img
//                     src={data.url}
//                     alt={data.alter}
//                     style={{
//                       objectFit: "cover",
//                       height: "100%",
//                       width: "auto",
//                     }}
//                   />
//                 </div>;
//               })}
//               <div style={styles.imagecontainer}>
//                 <img
//                   src="/images/image1.jpg"
//                   alt="Image 1"
//                   style={{ objectFit: "cover", height: "100%", width: "auto" }}
//                 />
//               </div>
//               <div style={styles.imagecontainer}>
//                 <img
//                   src="/images/image2.jpg"
//                   alt="Image 2"
//                   style={{ objectFit: "cover", height: "100%", width: "auto" }}
//                 />
//               </div>
//               <div style={styles.imagecontainer}>
//                 <img
//                   src="/images/image3.jpg"
//                   alt="Image 3"
//                   style={{ objectFit: "cover", height: "100%", width: "auto" }}
//                 />
//               </div>
//               <div style={styles.imagecontainer}>
//                 <img
//                   src="/images/image4.png"
//                   alt="Image 4"
//                   style={{ objectFit: "cover", height: "100%", width: "auto" }}
//                 />
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// const styles = {
//   wrap: {
//     margin: "0 20px 0 0",
//     display: "flex",
//     justifyContent: "center",
//     alignitems: "center",
//   },
//   button: {
//     cursor: "pointer",
//     padding: "10px 15px",
//   },
//   content: {
//     // backgroundColor: "#444",
//     width: "auto",
//     height: "250px",
//     position: "absolute",
//     height: "170px",
//     paddingRight: "10px",
//   },
//   hitter: {
//     width: "100vw",
//     height: "100vh",
//     position: "absolute",
//     top: 0,
//     left: 0,
//     zIndex: 1,
//   },
//   imagecontainer: {
//     width: "100px",
//     height: "inherit",
//     margin: "10px",
//     // padding: "0 20px",
//     border: "2px solid black",
//   },
// };

// export default Preview;

// import React, { useState } from "react";
// import Invoice1 from "../Forms/invoice1/Invoice1";
// import Invoice2 from "../Forms/invoice2/Invoice2";
// import Invoice3 from "../Forms/invoice3/Invoice3";
// import Invoice4 from "../Forms/invoice4/Invoice4";

// const containers2 = [
//   {
//     id: 1,
//     url: "https://images.unsplash.com/photo-1729742201799-3b163cf49cc9?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//     alter: "invoice1",
//   },
//   {
//     id: 2,
//     url: "https://images.unsplash.com/photo-1729883216787-2fa48c90c064?q=80&w=1949&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//     alter: "invoice2",
//   },
//   {
//     id: 3,
//     url: "https://images.unsplash.com/photo-1729707771991-3f4fb03885ad?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//     alter: "invoice3",
//   },
//   {
//     id: 4,
//     url: "https://images.unsplash.com/photo-1729704414861-42ecf6c9db59?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
//     alter: "invoice4",
//   },
// ];

// const PreviewandPopup = () => {
//   const [isVisible, setIsVisible] = useState(false);
//   const [selectedContainer, setSelectedContainer] = useState(null);

//   // const containers = [
//   //   { id: 1, url: "https://images.unsplash.com/photo-1699247290824-8f1cad179229?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", alter: "invoice1" },
//   //   { id: 2, url: "https://images.unsplash.com/photo-1711619034401-6eb679e5203c?q=80&w=1964&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", alter: "invoice2" },
//   //   { id: 3, url: "https://images.unsplash.com/photo-1719294843896-da1fc5d3b748?q=80&w=1886&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", alter: "invoice3" },
//   //   { id: 4, url: "https://images.unsplash.com/photo-1712309566108-85422f2466ff?q=80&w=1935&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", alter: "invoice4" },
//   // ];

//   const containers = [
//     { id: 1, url: "/images/image1.jpg", alter: "invoice1" },
//     { id: 2, url: "/images/image2.jpg", alter: "invoice2" },
//     { id: 3, url: "/images/image3.jpg", alter: "invoice3" },
//     { id: 4, url: "/images/image4.png", alter: "invoice4" },
//   ];

//   const handleToggle = () => {
//     setIsVisible(!isVisible);
//   };

//   const togglePopup = (id) => {
//     setSelectedContainer(selectedContainer === id ? null : id);
//   };

//   return (
//     <>
//       <style>
//         {`
//           .wrap {
//             margin: 0 20px 0 0;
//             display: flex;
//             justify-content: center;
//           }
//           .button {
//             cursor: pointer;
//             padding: 10px 15px;
//             width: 75px;
//             height: 35px;
//             margin-top: 10px;
//           }
//           .content {
//             width: auto;
//             height: 250px;
//             position: relative;
//             padding-right: 10px;
//           }
//           .imagecontainer {
//             width: 100px;
//             height: auto;
//             margin: 10px;
//             border: 2px solid black;
//             cursor: pointer;
//             transition: all 0.5s ease-out;
//           }
//           .imagecontainer:hover {
//             transform: scale(1.1);
//           }
//           .popup {
//             position: absolute;
//             top: 50%;
//             left: 50%;
//             transform: translate(-50%, -50%);
//             background-color: white;
//             padding: 20px;
//             box-shadow: 0 4px 8px rgba(0,0,0,0.2);
//             z-index: 2;
//           }
//         `}
//       </style>

//       <div className="wrap">
//         <button
//           className="button"
//           onClick={handleToggle}
//           aria-expanded={isVisible}
//         >
//           {isVisible ? "Hide" : "Preview"}
//         </button>
//       </div>
//       <div
//         style={{
//           width: "100%",
//           display: "flex",
//           justifyContent: "center",
//           marginTop: "50px",
//           marginBottom: "100px",
//         }}
//       >
//         {isVisible && (
//           <div className="content">
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 width: "100%",
//                 height: "inherit",
//               }}
//             >
//               {containers.map((data) => (
//                 <div
//                   key={data.id}
//                   className="imagecontainer"
//                   onClick={() => togglePopup(data.id)}
//                 >
//                   <img
//                     src={data.url}
//                     alt={data.alter}
//                     style={{
//                       objectFit: "cover",
//                       height: "100%",
//                       width: "inherit",
//                     }}
//                   />
//                 </div>
//               ))}
//             </div>
//             {selectedContainer && (
//               <div className="popup">
//                 {/* <img
//                   src={containers2.find(container => container.id === selectedContainer)?.url}
//                   alt={containers2.find(container => container.id === selectedContainer)?.alter}
//                   style={{ width: "100%", height: "auto" }}
//                 /> */}
// <section>

// </section>

//                 <section style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
//                   <div>
//                     <button onClick={() => setSelectedContainer(null)} style={{marginRight:"10px",background:"red",borderRadius:"5px"}}>
//                       Close
//                     </button>
//                     <button style={{marginLeft:"10px",borderRadius:"5px"}}>Print</button>
//                   </div>
//                 </section>
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default PreviewandPopup;

// // ===========================================================================================================================================================
// // ===========================================================================================================================================================
// // ===========================================================================================================================================================
// // ===========================================================================================================================================================
// // ===========================================================================================================================================================

// import React, { useState, useRef } from "react";
// import Invoice1 from "../Forms/invoice1/Invoice1";
// import Invoice2 from "../Forms/invoice2/Invoice2";
// import Invoice3 from "../Forms/invoice3/Invoice3";
// import Invoice4 from "../Forms/invoice4/Invoice4";
// import ReactToPrint from "react-to-print";

// const PreviewandPopup = () => {
//   const [isVisible, setIsVisible] = useState(false);
//   const [selectedContainer, setSelectedContainer] = useState(null);

//   const containers2 = [
//     { id: 1, component: <Invoice1 />, alter: "invoice1" },
//     { id: 2, component: <Invoice2 />, alter: "invoice2" },
//     { id: 3, component: <Invoice3 />, alter: "invoice3" },
//     { id: 4, component: <Invoice4 />, alter: "invoice4" },
//   ];

//   const containers = [
//     { id: 1, url: "/images/image1.jpg", alter: "invoice1" },
//     { id: 2, url: "/images/image2.jpg", alter: "invoice2" },
//     { id: 3, url: "/images/image3.jpg", alter: "invoice3" },
//     { id: 4, url: "/images/image4.png", alter: "invoice4" },
//   ];

//   const handleToggle = () => {
//     setIsVisible(!isVisible);
//   };

//   const togglePopup = (id) => {
//     setSelectedContainer(selectedContainer === id ? null : id);
//   };

//   return (
//     <>
//       <style>
//         {`
//           .wrap {
//             margin: 0 20px 0 0;
//             display: flex;
//             justify-content: center;
//           }
//           .button {
//             cursor: pointer;
//             padding: 10px 15px;
//             width: 75px;
//             height: 35px;
//             margin-top: 10px;
//           }
//           .content {
//             width: auto;
//             height: 250px;
//             position: relative;
//             padding-right: 10px;
//           }
//           .imagecontainer {
//             width: 100px;
//             height: auto;
//             margin: 10px;
//             // border: 2px solid black;
//             cursor: pointer;
//             transition: all 0.5s ease-out;
//           }
//           .imagecontainer:hover {
//             transform: scale(1.1);
//           }
//           .popup {
//             position: absolute;
//             // top: 50%;
//             // left: 50%;
//             // top: 0px;
//             left: 50%;
//             // bottom:650px;
//             bottom:-85%;
//             transform: translate(-50%, -50%);
//             background-color: white;
//             padding: 20px;
//             box-shadow: 0 4px 8px rgba(0,0,0,0.2);
//             z-index: 2;
//             width:65vw;
//             height:auto;
//           }
//         `}
//       </style>

//       <div className="wrap">
//         <button
//           className="button"
//           onClick={handleToggle}
//           aria-expanded={isVisible}
//         >
//           {isVisible ? "Hide" : "Preview"}
//         </button>
//       </div>
//       <div
//         style={{
//           width: "100%",
//           display: "flex",
//           justifyContent: "center",
//           marginTop: "50px",
//           marginBottom: "100px",
//         }}
//       >
//         {isVisible && (
//           <div className="content">
//             <div
//               style={{
//                 display: "flex",
//                 justifyContent: "center",
//                 alignItems: "center",
//                 width: "100%",
//                 height: "inherit",
//               }}
//             >
//               {containers.map((data) => (
//                 <div
//                   key={data.id}
//                   className="imagecontainer"
//                   onClick={() => togglePopup(data.id)}
//                 >
//                   <img
//                     src={data.url}
//                     alt={data.alter}
//                     style={{
//                       objectFit: "cover",
//                       height: "100%",
//                       width: "inherit",
//                     }}
//                   />
//                 </div>
//               ))}
//             </div>

//             {selectedContainer && (
//               <div className="popup">
//                 <section>
//                   {
//                     containers2.find(
//                       (container) => container.id === selectedContainer
//                     )?.component
//                   }
//                 </section>
//                 <section
//                   style={{
//                     display: "flex",
//                     justifyContent: "center",
//                     alignItems: "center",
//                   }}
//                 >
//                   <div>
//                     <button
//                       onClick={() => setSelectedContainer(null)}
//                       style={{
//                         marginRight: "10px",
//                         background: "red",
//                         borderRadius: "5px",
//                       }}
//                     >
//                       Close
//                     </button>
//                     <button
//                       onClick={() => setSelectedContainer(null)}
//                       style={{
//                         position: "absolute",
//                         color: "white",
//                         background: "red",
//                         top: "0px",
//                         right: "0px",
//                         borderRadius: "5px",
//                         border: "0px",
//                       }}
//                     >
//                       X
//                     </button>
//                   </div>
//                 </section>
//               </div>
//             )}
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default PreviewandPopup;

import React, { useContext, useState } from "react";
import Invoice1 from "../Forms/invoice1/Invoice1";
import Invoice2 from "../Forms/invoice2/Invoice2";
import Invoice3 from "../Forms/invoice3/Invoice3";
import Invoice4 from "../Forms/invoice4/Invoice4";
import MyContext from "./Context";


const PreviewandPopup = () => {

  const [isVisible, setIsVisible] = useState(false);
  // const [selectedContainer, setSelectedContainer] = useState(null);
  // const [forceRerender, setForceRerender] = useState(0); // Used to force re-render

  const {forceRerender,selectedContainer,setSelectedContainer,setForceRerender} = useContext(MyContext);


  const containers2 = [
    { id: 1, component: <Invoice1 />, alter: "invoice1" },
    { id: 2, component: <Invoice2 />, alter: "invoice2" },
    { id: 3, component: <Invoice3 />, alter: "invoice3" },
    { id: 4, component: <Invoice4 />, alter: "invoice4" },
  ];

  const containers = [
    { id: 1, url: "/images/image1.jpg", alter: "invoice1" },
    { id: 2, url: "/images/image2.jpg", alter: "invoice2" },
    { id: 3, url: "/images/image3.jpg", alter: "invoice3" },
    { id: 4, url: "/images/image4.png", alter: "invoice4" },
  ];

  const handleToggle = () => {
    setIsVisible(!isVisible);
  };

  const togglePopup = (id) => {
    setSelectedContainer((prev) => (prev === id ? null : id));
  };

  const closePopup = () => {
    setSelectedContainer(null);
    setForceRerender((prev) => prev + 1); // Trigger re-render
  };

  return (
    <>
      <div className="wrap">
        <button
          className="button"
          onClick={handleToggle}
          aria-expanded={isVisible}
        >
          {isVisible ? "Hide" : "Preview"}
        </button>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "50px",
          marginBottom: "100px",
        }}
      >
        {isVisible && (
          <div className="content">
            <div
              style={{
                display: "flex",
                // justifyContent: "center",
                // alignItems: "center",
                flexDirection: "column",
                width: "100%",
                // height: "inherit",
              }}
            >
              {containers.map((data) => (
                <div
                  key={data.id}
                  className="imagecontainer"
                  onClick={() => togglePopup(data.id)}
                >
                  <img
                    src={data.url}
                    alt={data.alter}
                    style={{
                      objectFit: "cover",
                      height: "100%",
                      width: "inherit",
                    }}
                  />
                </div>
              ))}
            </div>

            {selectedContainer && (
              <div key={forceRerender} className="popup">
                <section>
                  {
                    containers2.find(
                      (container) => container.id === selectedContainer
                    )?.component
                  }
                </section>
                <section
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div>
                    {/* <button
                      onClick={closePopup}
                      style={{
                        marginRight: "10px",
                        background: "red",
                        borderRadius: "5px",
                        color: "white",
                        border: "none",
                        padding: "5px 10px",
                      }}
                    >
                      Close
                    </button> */}
                    <button
                      onClick={closePopup}
                      style={{
                        position: "absolute",
                        color: "white",
                        background: "red",
                        top: "10px",
                        right: "10px",
                        borderRadius: "5px",
                        border: "0px",
                        padding: "5px",
                      }}
                    >
                      X
                    </button>
                  </div>
                </section>
              </div>
            )}
          </div>
        )}
      </div>
      <style>
        {`
          .wrap {
            margin: 0 20px 0 0;
            display: flex;
            justify-content: center;
          }
          .button {
            cursor: pointer;
            padding: 10px 15px;
            width: 75px;
            height: 35px;
            margin-top: 10px;
          }
          .content {
            width: auto;
            height: 250px;
            position: relative;
            padding-right: 10px;
          }
          .imagecontainer {
            width: 100px;
            height: auto;
            margin: 10px;
            cursor: pointer;
            transition: all 0.5s ease-out;
          }
          .imagecontainer:hover {
            transform: scale(1.1);
          }
          .popup {
            position: absolute;
            left: 495%;
            bottom: -458%;
            transform: translate(-50%, -50%);
            background-color: white;
            padding: 20px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            z-index: 2;
            width: 65vw;
            height: auto;
          }
        `}
      </style>
    </>
  );
};

export default PreviewandPopup;
